import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-list-step",
  templateUrl: "./list-step.component.html",
  styleUrls: ["./list-step.component.scss"],
})
export class ListStepComponent implements OnInit {
  @Output() nextStep = new EventEmitter();
  selectList: boolean = false;
  createList: boolean = false;
  selectedList: any;
  selectedOption: any;
  contactLists: any[] = [];
  constructor() {}

  ngOnInit() {
    this.getAllContactLists()
  }
  getAllContactLists() {
    this.contactLists = []
  }

  emitData() {
    let stepOneData = {};
    if (!!this.selectedOption && !!this.selectedList) {
      console.log(!!this.selectedOption, !!this.selectedList);
      stepOneData = {
        step: "1",
        optionType: this.selectedOption,
        selectedList: this.selectedList,
        nextStep: true,
      };
    } else {
      stepOneData = {
        step: "1",
        nextStep: false,
      };
    }
    this.nextStep.emit(stepOneData);
  }
  toggleOption(option) {
    if (option === "select") {
      console.log("select");
      this.selectList = !this.selectList;
      this.createList = false;
    } else {
      console.log("create");
      this.createList = !this.createList;
      this.selectList = false;
    }
    this.selectedOption = option;
    this.emitData();
  }
  toggleList(value) {
    console.log(value);
    if (this.selectedList == value) this.selectedList = null;
    else this.selectedList = value;
    this.emitData();
  }
}
